import { render, staticRenderFns } from "./ClaimsPerStatusChart.vue?vue&type=template&id=7433d3de&scoped=true"
import script from "./ClaimsPerStatusChart.vue?vue&type=script&lang=js"
export * from "./ClaimsPerStatusChart.vue?vue&type=script&lang=js"
import style0 from "./ClaimsPerStatusChart.vue?vue&type=style&index=0&id=7433d3de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7433d3de",
  null
  
)

export default component.exports